export enum Themes {
  BlackAndWhite = 'BLACK_AND_WHITE',
}
